/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseApiService from '../baseApi.service';

export default class ReferralCampaignService extends BaseApiService {
  readonly basePath: string = 'referralCampaign/v1';
  constructor(props = null) {
    super(props);
  }
}
